/* unplugin-vue-components disabled */import script from "./header.vue?vue&type=script&lang=jsx"
export * from "./header.vue?vue&type=script&lang=jsx"

import "./header.vue?vue&type=style&index=0&id=71823521&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71823521"]])

export default __exports__